import { all, fork } from 'redux-saga/effects';

import watchWhatsAppRequest from './whatsAppRequest';

function* whatsAppSagas() {
  yield all([fork(watchWhatsAppRequest)]);
}

export default whatsAppSagas;
